import * as constant from './constant'
async function imageExists(image_url) {

    let http = new XMLHttpRequest();
    try {
        await http.open('HEAD', image_url, false);
        await http.send();
        return http.status != 404;
    } catch (error) {
        console.error(error)
        return false
    }


}
export const mutations = {
    [constant.AUTH_PROFILE](state, payload) {
        if (payload) {
            state.isLogin = true;
            state.user = payload.result
        }
    },
    [constant.AUTH_REPLACE_PROFILE](state, payload) {
        if (payload) {

            state.user.displayName = payload.display_name
            if (!imageExists(state.user.profileUrl)) {
                state.user.profileUrl = payload.picture_url
            }
            if (payload.email !== '' && payload.email) {
                state.user.email = payload.email
            }

        }
    },
    [constant.AUTH_LOGOUT](state) {
        state.isLogin = false;
        state.user = {}
    },
}